// extracted by mini-css-extract-plugin
export default {"headerBlock":"headerBlock_headerBlock__n0-+I","headerBlock__action":"headerBlock_headerBlock__action__kplPQ"};